/* eslint-disable @typescript-eslint/no-explicit-any */
import { Checkbox } from '@festo-ui/react';
import React, { useEffect, useState } from 'react';
import { useTranslation } from '../../../hooks/useTranslation';
import { resistanceTypeImg } from '../../ResistantTypeImg';
import { OptionsType, OptionType } from '../multiselectbox/types';
import '../checkbox/CheckboxGroup.scss';

interface FacetWrapperProps {
  options: OptionsType;
  label: string;
  onChange: (values: any) => void;
  selected: OptionsType;
}

export default function CheckBoxGroup(props: FacetWrapperProps): JSX.Element | null {
  const t = useTranslation();

  return (
    <div className="resistance-categories-contanier">
      <label className="radio-label pb-3">{props.label}</label>
      {props.options.map((option) => {
        const checked = props.selected.includes(option.resistance);
        return (
          <div className="pb-2" title={t(option.translationKey)}>
            <Checkbox
              key={option.id}
              id={option.id}
              onChange={() => props.onChange(option.resistance)}
              name={props.label}
              value={option.resistance}
              checked={checked}
            >
              <img
                alt={`${t(option.translationKey)}`}
                className="filterIcon-img"
                src={resistanceTypeImg[option.resistance]['SIZE_16']}
              ></img>{' '}
              {option.resistance === 'CONDITIONALLY_RESISTANT'
                ? t(option.translationKey) + '*'
                : t(option.translationKey)}
            </Checkbox>
          </div>
        );
      })}
    </div>
  );
}
